import React from 'react';
import jwt_decode from 'jwt-decode';
import {
  Dialog,
  Button,
  Typography,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@material-ui/core';
import { getISODateTimeString } from '../../../utils/dateUtils';

const TokenMOdal: React.FC<{
  openIDToken: string | null;
  setOpenIDToken(value: string | null): void;
}> = ({ openIDToken, setOpenIDToken }) => {
  let decoded: any = {};
  let sub = '';
  let iat = 0;
  let exp = 0;
  let name = '';
  let email = '';
  try {
    decoded = jwt_decode(openIDToken as string);
    sub = decoded.sub || '';
    name = decoded.name || '';
    email = decoded.email || '';
    iat = decoded.iat || 0;
    exp = decoded.exp || 0;
  } catch {
    return null;
  }

  return openIDToken ? (
    <Dialog open={!!openIDToken}>
      <DialogTitle id="form-dialog-title">JWT OpenID Token</DialogTitle>
      <DialogContent dividers>
        <Typography variant="caption" color="textSecondary">
          Token
        </Typography>
        <Typography gutterBottom>
          {`${openIDToken.substring(0, 50)}...`}
        </Typography>
      </DialogContent>
      <DialogContent>
        <Typography variant="caption" color="textSecondary">
          Name
        </Typography>
        <Typography gutterBottom>{name}</Typography>
        <Typography variant="caption" color="textSecondary">
          Sub
        </Typography>
        <Typography gutterBottom>{sub}</Typography>
        <Typography variant="caption" color="textSecondary">
          Email
        </Typography>
        <Typography gutterBottom>{email}</Typography>
        <Typography variant="caption" color="textSecondary">
          Initial Date
        </Typography>
        <Typography gutterBottom>{getISODateTimeString(iat)}</Typography>
        <Typography variant="caption" color="textSecondary">
          Expiration Date
        </Typography>
        <Typography gutterBottom>{getISODateTimeString(exp)}</Typography>
      </DialogContent>

      <DialogActions>
        <Button
          onClick={() => {
            setOpenIDToken(null);
          }}
          color="primary"
        >
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  ) : null;
};

export default TokenMOdal;
